///////////////// HOOKS //////////////
import React, { useEffect, useState } from "react";
import {
  Accordion,
  Button,
  Modal,
  Form,
  Row,
  Col,
  Dropdown,
  FloatingLabel,
} from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

///////////////// STORE //////////////
import { getCarrinho, putCarrinho, deleteCarrinho } from "../../../store/Carrinho";
import { postPedido, putPedido } from "../../../store/Pedidos";

///////////////// COMPONENTS //////////////
import { MdModeEditOutline } from "react-icons/md";
import { FaRegTrashCan, FaUpLong } from "react-icons/fa6";
import { FcCheckmark, FcCancel } from "react-icons/fc";
import { NumericFormat } from "react-number-format";
import LoadingIcon from "../../../components/loading/Loading";
import { convertDecimal } from "../../../function/maskInputMoney";
import api from "../../../services/api";
import { IoRefresh, IoCartOutline, IoClose } from "react-icons/io5";

const empresa = process.env.REACT_APP_NAME;

const MENSAGENS_DE_ERRO = {
  filial: "Filial não selecionada",
  cliente: "Cliente não selecionado",
  transportadora: "Transportadora não selecionada",
  tipoTransportadora: "Tipo de frete não selecionada",
  condPagamento: "Condição de Pagamento não selecionada",
  tabPreco: "Tabela de preço não selecionada",
  carrinho: "Não existe produto no carrinho",
  qtd: "Quantidade indisponível",
  preco: "Preço inválido",
  desconto: "Desconto inválido",
  descontoPc: "Não podem ser concedidos descontos acima de 60%",
};

const ViewCarrinho = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { selectCli } = useSelector((state) => state.clienteReduce);
  const { dataCarrinho } = useSelector((state) => state.carrinhoReduce);
  const { select } = useSelector((state) => state.filialReduce);
  const {
    selectTransportadora,
    selectRedespacho,
    selectTipoTransportadora,
  } = useSelector((state) => state.transpReduce);
  const { selectCondPagamento } = useSelector((state) => state.condPagReduce);
  const { selectTabelaPreco } = useSelector((state) => state.precoReduce);
  const { dataUser, selectUser } = useSelector((state) => state.userReduce);

  const [refresh, setRefresh] = useState(true);
  const [errorForm, setErrorForm] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [show, setShow] = useState(false);
  const [error, setError] = useState({
    filial: "",
    cliente: "",
    carrinho: "",
    tipoTransportadora: "",
    transportadora: "",
    condPagamento: "",
    tabPreco: "",
  });
  const [toEmail, setToEmail] = useState("");
  const [loadingEmail, setLoadingEmail] = useState(false);
  const [loadingSendPed, setLoadingSendPed] = useState(false);
  const [numCotacao, setNumCotacao] = useState({});
  const [erroMassage, setErroMassage] = useState({});

  // Atualiza carrinho e email do cliente quando necessário
  useEffect(() => {
    dispatch(getCarrinho());
    setError({});
    setToEmail(selectCli.emailCliente);
  }, [dispatch, refresh, selectCli, props.show]);
  
  // Validação dos campos e dos itens do carrinho
  const validar = () => {
    let numErrors = 0;
    const errorMessage = { carrinho: [] };

    if (!select || !select.idFilial) {
      errorMessage.filial = MENSAGENS_DE_ERRO.filial;
      numErrors++;
    }
    if (!selectCli || !selectCli.codCliente) {
      errorMessage.cliente = MENSAGENS_DE_ERRO.cliente;
      numErrors++;
    }
    if (!selectTransportadora || !selectTransportadora.idErpTransp) {
      errorMessage.transportadora = MENSAGENS_DE_ERRO.transportadora;
      numErrors++;
    }
    if (!selectTipoTransportadora || !selectTipoTransportadora.value) {
      errorMessage.tipoTransportadora = MENSAGENS_DE_ERRO.tipoTransportadora;
      numErrors++;
    }
    if (!selectCondPagamento || !selectCondPagamento.idErpCondPag) {
      errorMessage.condPagamento = MENSAGENS_DE_ERRO.condPagamento;
      numErrors++;
    }
    if (!selectTabelaPreco || !selectTabelaPreco.codTabPreco) {
      errorMessage.tabPreco = MENSAGENS_DE_ERRO.tabPreco;
      numErrors++;
    }
    if (dataCarrinho.length < 1) {
      errorMessage.carrinho[0] = MENSAGENS_DE_ERRO.carrinho;
      numErrors++;
    }

    dataCarrinho.forEach((obj, index) => {
      let msg = "";
      if (
        typeof obj.quantidade === "undefined" ||
        obj.quantidade <= 0 ||
        isNaN(obj.quantidade)
      ) {
        msg += MENSAGENS_DE_ERRO.qtd + " ;";
        numErrors++;
      }
      if (obj.qtpcs && obj.quantidade % obj.qtpcs !== 0) {
        msg += "Quantidade inválida ;";
        numErrors++;
      }
      if (typeof obj.preco === "undefined" || obj.preco <= 0) {
        msg += MENSAGENS_DE_ERRO.preco + " ;";
        numErrors++;
      }
      if (
        typeof obj.desconto === "undefined" ||
        obj.desconto >= obj.quantidade * obj.preco
      ) {
        msg += MENSAGENS_DE_ERRO.desconto + " ;";
        numErrors++;
      }
      if (obj.descontoPc > 60) {
        msg += MENSAGENS_DE_ERRO.descontoPc;
        numErrors++;
      }
      errorMessage.carrinho[index] = msg
        ? `(Item ${index + 1}) Produto ${obj.codProduto}: ${msg}`
        : "";
    });

    setError(errorMessage);
    return numErrors === 0;
  };
  // Finaliza o orçamento
  const finalizaOrcamento = async () => {
    setLoadingSendPed(true);
    const newDate = new Date();
    const date = `${newDate.getFullYear()}${("0" + (newDate.getMonth() + 1)).slice(-2)}${(
      "0" + newDate.getDate()
    ).slice(-2)}`;
    if (validar()) {
      const arrayTransformado = dataCarrinho.map((obj) => ({
        filial: obj.filial,
        codProduto: obj.codProduto,
        nmProduto: obj.nmProduto,
        um: obj.um,
        codColecao: obj.codColecao,
        quantidade: parseFloat(obj.quantidade),
        preco: obj.preco,
        desconto: obj.desconto,
        descontoPc: obj.descontoPc,
        pedido: obj.pedido || "",
        ipi: obj.ipi || 0,
        pedCliente: props.dataorc.pedCliente || "",
        total: obj.preco * parseFloat(obj.quantidade),
        obs: obj.obs || "",
      }));

      const form = {
        filial: select.idFilial,
        codPedido: props.dataorc.codPedido ? props.dataorc.codPedido : "",
        tipo: "1",
        codCliente: selectCli.codCliente,
        codLoja: selectCli.codLoja,
        codTransportadora: selectTransportadora.idErpTransp,
        codRedespacho: selectRedespacho ? selectRedespacho.idErpTransp : "",
        tipoCliente: "R",
        condPagamento: selectCondPagamento.idErpCondPag,
        tabela: selectTabelaPreco.codTabPreco,
        vendedor: selectCli.codVendedor,
        comissao: selectUser.comissao.toString(),
        emissao: date,
        tipoFrete: selectTipoTransportadora.value,
        observacao: props.dataorc.observacao,
        email: props.dataorc.email,
        ativo: "0",
        item: arrayTransformado,
      };

      try {
        const resp = await postPedido(form);
        if (resp.status === 200) {
          setNumCotacao(resp.data.pedidos[0]);
          setShow(true);
        } else {
          setLoadingSendPed(false);
        }
      } catch (error) {
        console.error("Erro ao finalizar pedido:", error);
      } finally {
        setLoadingSendPed(false);
      }
    } else {
      setLoadingSendPed(false);
    }
  };

  // Fecha o modal e limpa o carrinho
  const fecharModal = () => {
    setShow(false);
    dispatch(deleteCarrinho("", true));
    navigate("/orcamentos");
  };

  // Calcula e exibe o total do carrinho (usa reduce para evitar atualização de state durante render)
  const TotalCarrinho = () => {
    const total = dataCarrinho.reduce((acc, item) => {
      return acc + ((item.preco * item.quantidade - item.desconto) * ((item.ipi / 100) + 1));
    }, 0);

    return (
      <div>
        <span className="font-bold">Total: R$ {convertDecimal(total.toFixed(2))}</span>
      </div>
    );
  };
  const getTotalCarrinho = () => {
    const total = dataCarrinho.reduce((acc, item) => {
      return (
        acc +
        ((item.preco * item.quantidade - item.desconto) *
          ((item.ipi / 100) + 1))
      );
    }, 0);
    return convertDecimal(total.toFixed(2));
  };
  
  // Envia e-mail com a cotação gerada
  const enviaEmail = async () => {
    setLoadingEmail(true);

    const formatarData = (data) => {
      const ano = data.substring(0, 4);
      const mes = data.substring(4, 6);
      const dia = data.substring(6, 8);
      return `${dia}/${mes}/${ano.substring(2, 4)}`;
    };

    const formToPDF = {
      cliente: selectCli.nmCliente,
      cotacao: numCotacao.codPedido.substring(3),
      revisao: numCotacao.revisao,
      emissao: formatarData(numCotacao.emissao),
      condPagamento: selectCondPagamento.nmCondPag,
      transportadora: selectTransportadora.nmTransp,
      redespacho: selectRedespacho?.nmTransp || " ",
      endereco: selectCli.endereco,
      itens: numCotacao.itens,
    };

    const gerarHTML = (numCotacao, dataFormatada) => `
      <html>
        <head>
          <style>
            table {
              font-family: arial, sans-serif;
              border-collapse: collapse;
              width: 100%;
            }
            td, th {
              border: 1px solid #dddddd;
              text-align: left;
              padding: 8px;
            }
            tr:nth-child(even) {
              background-color: #dddddd;
            }
          </style>
        </head>
        <body>
          <p>Olá ${selectCli.nmCliente},</p>
          <p>Abaixo cotação enviado pelo representante:</p>
          <br/>
          <p>Cotação: ${numCotacao.codPedido.substring(3)} || Revisão: ${numCotacao.revisao}</p>
          <p>Emiss&atilde;o: ${dataFormatada}</p>
          <table>
            <thead>
              <tr>
                <th>Código</th>
                <th>Produto</th>
                <th>Local</th>
                <th>Qtd.</th>
                <th>Valor</th>
                <th>Desc.</th>
                <th>Ipi</th>
                <th>Total</th>
                <th>Pedido de compra</th>
                <th>Obs</th>
              </tr>
            </thead>
            <tbody>
              ${numCotacao.itens
                .map(
                  (item) => `
                <tr>
                  <td>${item.codProduto}</td>
                  <td>${item.nmProduto}</td>
                  <td>${item.codColecao}</td>
                  <td>${parseFloat(item.quantidade).toFixed(2)}</td>
                  <td>${convertDecimal(item.preco.toFixed(2))}</td>
                  <td>${convertDecimal(item.desconto.toFixed(2))}</td>
                  <td>${item.ipi}</td>
                  <td>${convertDecimal(
                    (
                      (parseFloat(item.quantidade) * item.preco - item.desconto) *
                      ((item.ipi / 100) + 1)
                    ).toFixed(2)
                  )}</td>
                  <td>${item.pedido}</td>
                  <td>${item.obs}</td>
                </tr>
              `
                )
                .join("")}
            </tbody>
          </table>
          <p class="font-bold">Total: R$ ${getTotalCarrinho()}</p>
          <br/>
          <p>Atenciosamente, ${empresa}.</p>
          <br/>
        </body>
      </html>
    `;

    const dataFormatada = formatarData(numCotacao.emissao);
    const htmlBody = gerarHTML(numCotacao, dataFormatada);

    try {
      const response = await api.post("/email/send_email", {
        from_email: "Pedidos Promex Mais <wf.pedidos@promexmais.com.br>",
        to_email: toEmail,
        subject: `Cotação - ${numCotacao.codPedido.substring(3)} || Revisão: ${numCotacao.revisao}`,
        html_body: htmlBody,
        detPedido: formToPDF,
      });

      if (response.status === 200) {
        await putPedido({ ...numCotacao, email: toEmail }, null);
        setErroMassage({ ...erroMassage, email: "" });
        fecharModal();
      } else {
        setErroMassage({ ...erroMassage, email: "Falha no envio do e-mail. Tente novamente." });
      }
    } catch (error) {
      setErroMassage({ ...erroMassage, email: "Falha no envio do e-mail. Verifique sua conexão e tente novamente." });
    } finally {
      setLoadingEmail(false);
    }
  };

  // Componente para renderizar cada item do carrinho
  const ItemProdCarrinho = ({ item, index, dataOrc }) => {
    const [itemProd, setItemProd] = useState({
      filial: select.idFilial,
      codCliente: dataOrc.codCliente,
      codVendedor: dataOrc.codVendedor,
      codProduto: item.codProduto,
      nmProduto: item.nmProduto,
      um: "UN",
      codColecao: item.codColecao,
      quantidade: item.quantidade || 0,
      preco: item.preco || 0,
      desconto: item.desconto || 0,
      descontoPc: item.descontoPc || 0,
      qtpcs: item.qtpcs || 1,
      pedido: item.pedido || "",
      ipi: item.ipi || 0,
      ativo: 0,
      id: index,
      qtdMax: item.qtdMax || 0,
    });
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [timer, setTimer] = useState(null);

    const deleteItemProd = () => {
      dispatch(deleteCarrinho(itemProd.id, false));
      setRefresh(!refresh);
    };

    const onChange = (value, type) => {
      let updatedProd = { ...itemProd };
      switch (type) {
        case "quantidade":
          updatedProd.quantidade = value;
          updatedProd.desconto =
            (updatedProd.descontoPc * (value * updatedProd.preco)) / 100;
          break;
        case "preco":
          updatedProd.preco = value;
          updatedProd.desconto =
            (updatedProd.descontoPc * (updatedProd.quantidade * value)) / 100;
          break;
        case "descontoPc":
          updatedProd.descontoPc = value;
          updatedProd.desconto =
            (value * (updatedProd.quantidade * updatedProd.preco)) / 100;
          break;
        case "pedido":
          updatedProd.pedido = value;
          break;
        default:
          break;
      }
      setItemProd(updatedProd);
      dispatch(putCarrinho({ ...updatedProd, id: index }));
      if (timer) clearTimeout(timer);
      const newTimer = setTimeout(() => setRefresh(!refresh), 1500);
      setTimer(newTimer);
    };

    return (
      <div
        className={`flex flex-col border-2 p-2 my-1 rounded-md w-full ${
          index % 2 ? "bg-gray-200" : ""
        }`}
      >
        <div className="flex flex-col justify-center w-full">
          <p className="text-sm font-bold my-0">{itemProd.nmProduto}</p>
          <p className="my-0 text-xs text-gray-500">{itemProd.codProduto}</p>
          {timer && <LoadingIcon />}
        </div>
        <div className="flex md:flex-row flex-col justify-center w-full md:space-x-2">
          <div className="flex flex-row md:w-2/3 space-x-2">
            <div className="w-2/4 p-0">
              <FloatingLabel
                controlId="floatingInput"
                label={itemProd.qtpcs !== 1 ? `Qtd. (x${itemProd.qtpcs})` : "Qtd."}
                className="my-2"
              >
                <NumericFormat
                  value={itemProd.quantidade}
                  decimalSeparator=","
                  decimalScale={2}
                  className="bg-slate-300"
                  allowNegative={false}
                  size="sm"
                  customInput={Form.Control}
                  onValueChange={(e) => onChange(e.floatValue, "quantidade")}
                />
              </FloatingLabel>
            </div>
            <div className="w-2/4 p-0">
              <FloatingLabel
                controlId="floatingInput"
                label={itemProd.ipi === 0 ? "Preço" : `Preço (ipi.${itemProd.ipi})`}
                className="my-2"
              >
                <NumericFormat
                  value={itemProd.preco ? itemProd.preco.toFixed(2) : 0}
                  decimalSeparator=","
                  prefix="R$ "
                  decimalScale={2}
                  size="sm"
                  allowNegative={false}
                  customInput={Form.Control}
                  onValueChange={(e) => onChange(e.floatValue, "preco")}
                  disabled
                />
              </FloatingLabel>
            </div>
          </div>
          <div className="w-2/4 p-0">
            <FloatingLabel
              controlId="floatingInput"
              label={
                itemProd.descontoPc
                  ? `Desc.% (R$ ${convertDecimal(itemProd.desconto.toFixed(2))})`
                  : "Desc.%"
              }
              className="my-2"
            >
              <NumericFormat
                value={itemProd.descontoPc || 0}
                decimalSeparator=","
                decimalScale={5}
                size="sm"
                allowNegative={false}
                customInput={Form.Control}
                onValueChange={(e) => onChange(e.floatValue, "descontoPc")}
              />
            </FloatingLabel>
          </div>
        </div>
        <div className="flex justify-between ml-1">
          <a
            onClick={() => setShowDeleteAlert(!showDeleteAlert)}
            className="text-blue-500 cursor-pointer"
          >
            Excluir
          </a>
          <p className="font-bold">
            {itemProd.quantidade
              ? "R$ " +
                convertDecimal(
                  (
                    (itemProd.quantidade * itemProd.preco - itemProd.desconto) *
                    ((itemProd.ipi / 100) + 1)
                  ).toFixed(2)
                )
              : "R$ 0,00"}
          </p>
        </div>
        <Modal
          show={showDeleteAlert}
          onHide={() => setShowDeleteAlert(false)}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton className="bg-green-500">
            <Modal.Title>
              Deseja remover produto {itemProd.codProduto}?
            </Modal.Title>
          </Modal.Header>
          <Modal.Footer>
            <Button variant="secondary" onClick={deleteItemProd}>
              Confirmar
            </Button>
            <Button variant="secondary" onClick={() => setShowDeleteAlert(false)}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  };

  // Lista todos os itens do carrinho
  const ItensCarrinho = ({ carrinho, dataOrc }) => {
    return (
      <div className="w-full">
        <h3>Produtos</h3>
        <div className="overflow-y-scroll w-full rounded-lg border p-1 mb-2">
          {carrinho.map((item, index) => (
            <ItemProdCarrinho key={index} item={item} index={index} dataOrc={dataOrc} />
          ))}
        </div>
      </div>
    );
  };

  return (
    <Modal {...props} size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton className="p-3">
        <Modal.Title id="contained-modal-title-vcenter">
          <h4 className="m-0">Finalizar Cotação</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-3">
        {errorForm && <p className="text-red-600">{errorForm}</p>}
        <div className="flex flex-col w-full rounded-lg border p-1 mb-2">
          {dataUser.length > 1 && (
            <div className="flex flex-col w-full my-1">
              <FloatingLabel controlId="floatingInput" label="Vendedor" className="my-1 w-full sm">
                <Form.Control defaultValue={selectUser.nmVendedor} readOnly />
              </FloatingLabel>
            </div>
          )}
          <div className="flex flex-col w-full">
            <FloatingLabel controlId="floatingInput" label="Cliente" className="my-1 w-full sm">
              <Form.Control defaultValue={selectCli.nmCliente} readOnly />
            </FloatingLabel>
            {error.cliente && <p className="text-xs text-red-500">{error.cliente}</p>}
          </div>
          <div className="flex flex-col md:flex-row md:space-x-4">
            <div className="w-full">
              <FloatingLabel controlId="floatingInput" label="Condição de Pagamento" className="my-2 w-full">
                <Form.Control defaultValue={selectCondPagamento?.nmCondPag} readOnly />
              </FloatingLabel>
              {error.condPagamento && <p className="text-xs text-red-500">{error.condPagamento}</p>}
            </div>
            <div className="w-full">
              <FloatingLabel controlId="floatingInput" label="Tabela de preço" className="my-2 w-full">
                <Form.Control defaultValue={selectTabelaPreco?.nmTabPreco || ''} readOnly />
              </FloatingLabel>
              {error.tabPreco && <p className="text-xs text-red-500">{error.tabPreco}</p>}
            </div>
          </div>
          <div className="flex flex-col md:flex-row md:space-x-4">
            <div className="w-full">
              <FloatingLabel controlId="floatingInput" label="Tipo Frete" className="my-2 w-full">
                <Form.Control defaultValue={selectTipoTransportadora?.label || ""} readOnly />
              </FloatingLabel>
              {error.tipoTransportadora && <p className="text-xs text-red-500">{error.tipoTransportadora}</p>}
            </div>
            <div className="w-full">
              <FloatingLabel controlId="floatingInput" label="Transportadora" className="my-2">
                <Form.Control defaultValue={selectTransportadora?.nmTransp || ""} readOnly />
              </FloatingLabel>
              {error.transportadora && <p className="text-xs text-red-500">{error.transportadora}</p>}
            </div>
          </div>
          {selectRedespacho && (
            <div className="w-full">
              <FloatingLabel controlId="floatingInput" label="Redespacho" className="my-2">
                <Form.Control defaultValue={selectRedespacho?.nmTransp || ""} readOnly />
              </FloatingLabel>
            </div>
          )}
          <FloatingLabel controlId="floatingInput" label="Pedido cliente" className="my-2">
            <Form.Control defaultValue={props.dataorc.pedCliente} readOnly />
          </FloatingLabel>
          <FloatingLabel controlId="floatingInput" label="Observação" className="my-2">
            <Form.Control defaultValue={props.dataorc.observacao} readOnly />
          </FloatingLabel>
        </div>
        <ItensCarrinho dataOrc={props.dataorc} carrinho={dataCarrinho} />
        {error.carrinho &&
          error.carrinho.length > 0 &&
          error.carrinho.map((msg, i) => msg && <p key={i} className="text-xs text-red-500">{msg}<br /></p>)}
      </Modal.Body>
      <Modal.Footer className="container" style={{ display: "unset" }}>
        <div className="row justify-content-start align-items-center">
          <div className="col-md-4 p-1">
            <TotalCarrinho />
          </div>
          <div className="col-md p-1 d-flex align-items-center justify-content-center">
            <Button
              variant="warning"
              size="sm"
              className="w-100 btn d-flex align-items-center justify-content-center"
              onClick={() => setShowAlert(true)}
            >
              <IoRefresh className="mr-1" />
              Limpar carrinho
            </Button>
          </div>
          <div className="col-md p-1 d-flex align-items-center justify-content-center">
            <Button
              disabled={loadingSendPed || !selectCli.codCliente}
              variant="success"
              size="sm"
              className="w-100 btn d-flex align-items-center justify-content-center"
              onClick={finalizaOrcamento}
            >
              <IoCartOutline className="mr-1" />
              Finalizar
            </Button>
          </div>
          <div className="col-md p-1 d-flex align-items-center justify-content-center">
            <Button
              variant="danger"
              size="sm"
              className="w-100 btn d-flex align-items-center justify-content-center"
              onClick={props.onHide}
            >
              <IoClose className="mr-1" />
              Fechar
            </Button>
          </div>
        </div>
      </Modal.Footer>
      <Modal
        show={showAlert}
        onHide={() => setShowAlert(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton className="bg-yellow-400">
          <Modal.Title className="fs-4">
            Deseja remover todos os itens do carrinho?
          </Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <Button
            variant="success"
            size="sm"
            onClick={() => {
              dispatch(deleteCarrinho("", true));
              props.onHide();
              setShowAlert(false);
            }}
          >
            Confirmar
          </Button>
          <Button variant="danger" size="sm" onClick={() => setShowAlert(false)}>
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={show}
        onHide={fecharModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton className="bg-green-500">
          <Modal.Title>
            Cotação gerada com sucesso! (
            {numCotacao.codPedido
              ? `Cotação ${numCotacao.codPedido.substring(3)}  Revisão ${numCotacao.revisao}`
              : ""}
            )
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Modal.Title className="fs-6">
            Deseja enviar cotação para cliente?
          </Modal.Title>
          <FloatingLabel
            controlId="floatingInput"
            label="Email (Separe os e-mails utilizando ; )"
            className="my-2"
          >
            <Form.Control
              value={toEmail}
              as="input"
              maxLength={140}
              onChange={(e) => setToEmail(e.target.value)}
            />
          </FloatingLabel>
          {erroMassage.email && <p className="text-xs text-red-500">{erroMassage.email}</p>}
        </Modal.Body>
        <Modal.Footer>
          {loadingEmail && <LoadingIcon />}
          <Button disabled={loadingEmail} variant="success" size="sm" onClick={enviaEmail}>
            {loadingEmail ? "Enviando..." : "Enviar"}
          </Button>
          <Button variant="danger" size="sm" onClick={fecharModal}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </Modal>
  );
};

export default ViewCarrinho;
